/**
 * Splits a string into two parts on the FIRST occurrence of a separator,
 * so that any further separators are preserved in the second part
 * (e.g. "a:b:c" split on ":" → { before: "a", after: "b:c" }).
 * When the separator is absent, the whole string becomes `before` and `after` is empty.
 * @param {string} str - the string to split, e.g. "user:pa:ss"
 * @param {string} separator - the separator to split on, e.g. ":"
 * @returns {{ before: string, after: string }} - e.g. { before: "user", after: "pa:ss" }
 */
export const splitStringOnFirst = (str = '', separator = '') => {
    const separatorIndex = str.indexOf(separator);

    if (separatorIndex === -1) {
        return { before: str, after: '' };
    }

    const before = str.slice(0, separatorIndex);
    const after = str.slice(separatorIndex + separator.length);

    return { before, after };
};
